import { activityInviteService, IActivityInvite } from '@/services/activityInviteService'
import { notify } from '@kyvg/vue3-notification'
import { ActionTree, GetterTree, MutationTree } from 'vuex'

class ActivityInviteState {
    receivedInvites: IActivityInvite[] = []
    sentInvites: IActivityInvite[] = []
}

const getters: GetterTree<ActivityInviteState, any> = {
    getReceivedInvites(store) {
        return () => store.receivedInvites
    },
    getSentInvites(store) {
        return () => store.sentInvites
    },
}

const mutations: MutationTree<ActivityInviteState> = {
    setReceivedInvites(state, payload: IActivityInvite[]) {
        state.receivedInvites = payload
    },
    setSentInvites(state, payload: IActivityInvite[]) {
        state.sentInvites = payload
    },
}

const doNotifyError = (message: string) => {
    notify({
        group: 'requests',
        title: 'Foutmelding',
        type: 'error',
        text: message,
    })
}

const actions: ActionTree<ActivityInviteState, any> = {
    getReceivedActivityInvites({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            activityInviteService
                .getReceivedActivityInvites(rootState.groups.selectedGroup.id)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        commit('setReceivedInvites', response.data)
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    getSentActivityInvites({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            activityInviteService
                .getSentActivityInvites(rootState.groups.selectedGroup.id)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        commit('setSentInvites', response.data)
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    sendActivityInvite({ rootState }, { activiteitIngeplandId, naarStamgroepId, bericht }: { activiteitIngeplandId: number; naarStamgroepId: number; bericht: string }) {
        return new Promise((resolve, reject) => {
            activityInviteService
                .sendActivityInvite({
                    stamgroepId: rootState.groups.selectedGroup.id,
                    activiteitIngeplandId: activiteitIngeplandId,
                    naarStamgroepId: naarStamgroepId,
                    bericht: bericht,
                })
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    acceptActivityInvite({ rootState }, inviteId: number) {
        return new Promise((resolve, reject) => {
            activityInviteService
                .acceptActivityInvite(rootState.groups.selectedGroup.id, inviteId)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    rejectActivityInvite({ rootState }, inviteId: number) {
        return new Promise((resolve, reject) => {
            activityInviteService
                .rejectActivityInvite(rootState.groups.selectedGroup.id, inviteId)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
}

export default {
    state: new ActivityInviteState(),
    getters: getters,
    mutations: mutations,
    actions: actions,
}
